import tracking from '../../utils/tracking';
import cookies, { cookieDomain, cookiePath } from '../../utils/cookies';
import localStorage from '../../utils/local-storage'; // analytics and env are left out for now

export const LS_KEY_TOKEN = 'token';
export const LS_KEY_LAST_DWELLING = '__/state/dwelling';
export const KEY_TRACKING = 'bn.trk';
export const KEY_UTM = 'bn.utm';

function cookieSafeKey(key) {
  return key.replace(/\//g, '_').replace('___', '__');
}

function clearCookie(key) {
  if (cookies.hasItem(cookieSafeKey(key))) {
    cookies.removeItem(cookieSafeKey(key), cookiePath, cookieDomain);
  }
}

function clearLS(key) {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
  }
}

function clear(key) {
  clearLS(key);
  clearCookie(key);
}

if (__CLIENT__) {
  try {
    // Persisted user token, automatic login
    if (cookies.hasItem(LS_KEY_TOKEN)) {
      localStorage.setItem(
        LS_KEY_TOKEN,
        JSON.parse(cookies.getItem(LS_KEY_TOKEN))
      );
      clearCookie(LS_KEY_TOKEN);
    }

    // Last dwelling
    if (cookies.hasItem(cookieSafeKey(LS_KEY_LAST_DWELLING))) {
      localStorage.setItem(
        LS_KEY_LAST_DWELLING,
        cookies.getItem(cookieSafeKey(LS_KEY_LAST_DWELLING))
      );
      clearCookie(LS_KEY_LAST_DWELLING);
    }

    // Tracking / Analytics queue from server
    if (cookies.hasItem(KEY_TRACKING)) {
      const trk = JSON.parse(cookies.getItem(KEY_TRACKING));
      if (Array.isArray(trk.actions)) {
        trk.actions.forEach(action => {
          tracking.action(action);
        });
      }
      cookies.removeItem(KEY_TRACKING, cookiePath);
    }

    // Handle utm params in URL
    if (/(\?|&)utm_/.test(global.location.search)) {
      const utmParams = [
        'utm_source',
        'utm_campaign',
        'utm_medium',
        'utm_content',
        'utm_term'
      ];
      const queries = global.location.search
        .replace(/^\?/, '')
        .split('&')
        .map(part => part.split('='));
      const utm = queries.reduce((acc, part) => {
        if (utmParams.indexOf(part[0]) !== -1) {
          acc[part[0].replace('utm_', '')] = part[1];
        }
        return acc;
      }, {});
      if (Object.keys(utm).length) {
        cookies.setItem(
          KEY_UTM,
          JSON.stringify(utm),
          24 * 60 * 60,
          cookiePath,
          cookieDomain
        );
      }
    }
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
  }
}

export function persistToken(payload) {
  if (__CLIENT__) {
    try {
      if (payload === null) {
        return clear(LS_KEY_TOKEN);
      }

      cookies.setItem(
        LS_KEY_TOKEN,
        JSON.stringify(payload),
        60 * 60,
        cookiePath,
        cookieDomain
      );
      localStorage.setItem(LS_KEY_TOKEN, payload);
      localStorage.setItem('user', '1');
    } catch (error) {
      console.error(error);
    }
  }
}

export function persistLastDwelling(payload) {
  if (__CLIENT__) {
    try {
      if (payload === null) {
        return clear(LS_KEY_LAST_DWELLING);
      }

      const { dwellingId, headline, image, images } = payload;
      const data = JSON.stringify({ dwellingId, headline, image, images });

      cookies.setItem(
        cookieSafeKey(LS_KEY_LAST_DWELLING),
        data,
        60 * 60,
        cookiePath,
        cookieDomain
      );
      localStorage.setItem(LS_KEY_LAST_DWELLING, data);
    } catch (error) {
      console.error(error);
    }
  }
}

export function getPersistedLastDwelling() {
  if (__CLIENT__) {
    try {
      const lastDwelling = localStorage.getItem(LS_KEY_LAST_DWELLING);
      return lastDwelling && JSON.parse(lastDwelling);
    } catch (err) {
      return null;
    }
  }
}
